module.exports = __webpack_public_path__ + "img/firma-harry.da8706f4.png";